const productData = [
  {
    id: 1,
    name: "The Great Result Gift Box",
    category: "Gift Boxes",
    price: "85.00",
    reviews: "342",
    rating: "4.6",
    image: "/generated/products/p01-01.jpg",
    images: ["/generated/products/p01-01.jpg", "/generated/products/p01-02.jpg", "/generated/products/p01-03.jpg", "/generated/products/p01-04.jpg", "/generated/products/p01-05.jpg", "/generated/products/p01-06.jpg", "/generated/products/p01-07.jpg"],
    size: ["One size"],
    colors: ["Classic"],
    material: "Wicker hamper, assorted food products",
    description: [
      "Created for graduations, new jobs and every hard-won milestone, this box makes congratulations feel generous and immediate.",
      "Sparkling wine is paired with caramel truffles, salted caramel almonds, playful chocolate tortoises and buttery honey biscuits.",
      "Send it to celebrate someone else, or open it for a well-earned treat.",
    ],
    Features: [
      "Prosecco N.V, 75cl 11.5% ABV",
      "Scottish Ling Heather Honey Biscuits, 250g",
      "Salted Caramel Almonds, 170g",
      "Milk and Dark Truffles, 135g",
      "A Triumph of Chocolate Tortoises Matchbox, 25g",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5189042",
    ],
  },
  {
    id: 2,
    name: "The Taste of failblossom Hamper",
    category: "Hampers",
    price: "75.00",
    reviews: "289",
    rating: "4.7",
    image: "/generated/products/p02-01.jpg",
    images: ["/generated/products/p02-01.jpg", "/generated/products/p02-02.jpg", "/generated/products/p02-03.jpg", "/generated/products/p02-04.jpg", "/generated/products/p02-05.jpg", "/generated/products/p02-06.jpg", "/generated/products/p02-07.jpg"],
    size: ["Mini Huntsman"],
    colors: ["Classic"],
    material: "Mini Huntsman wicker hamper, assorted food products",
    description: [
      "There's nothing like a thoughtfully filled failblossom hamper.",
      "This compact wicker introduces our world of generous gifting with tea, coffee, fruit preserves and confectionery selected for easy sharing.",
    ],
    Features: [
      "Please note, the items in this hamper will not arrive gift wrapped.",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5161891",
    ],
  },
  {
    id: 3,
    name: "The Birthday Present Hamper",
    category: "Hampers",
    price: "200.00",
    reviews: "214",
    rating: "4.5",
    image: "/generated/products/p03-01.jpg",
    images: ["/generated/products/p03-01.jpg", "/generated/products/p03-02.jpg", "/generated/products/p03-03.jpg", "/generated/products/p03-04.jpg", "/generated/products/p03-05.jpg", "/generated/products/p03-06.jpg", "/generated/products/p03-07.jpg"],
    size: ["Large"],
    colors: ["Classic"],
    material: "Wicker hamper, assorted food products",
    description: [
      "Let the celebrations begin.",
      "Designed to delight from the moment it is opened, this cheerful hamper pairs celebratory bubbles, tea and sweet treats for a birthday worth remembering.",
    ],
    Features: [
      "Blanc de Blancs Grand Cru Champagne N.V, 75cl",
      "Ceylon Orange Pekoe Loose Leaf Tin, 125g",
      "Dark  Chocolate  Fruit & Nut Bar, 80g",
      "Musical Birthday Biscuit Tin, 475g",
      "Dark Chocolate Florentines, 150g",
      "Triple Chocolate Panettone Loaf, 270g",
      "Marc de Champagne Truffle Drum, 125g",
      "Gold Birthday Candles",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5246732",
    ],
  },
  {
    id: 4,
    name: "The Birthday Celebration Hamper",
    category: "Hampers",
    price: "200.00",
    reviews: "178",
    rating: "4.6",
    image: "/generated/products/p04-01.jpg",
    images: ["/generated/products/p04-01.jpg", "/generated/products/p04-02.jpg", "/generated/products/p04-03.jpg", "/generated/products/p04-04.jpg", "/generated/products/p04-05.jpg", "/generated/products/p04-06.jpg", "/generated/products/p04-07.jpg"],
    size: ["Medium"],
    colors: ["Classic"],
    material: "Wicker hamper, assorted food products",
    description: [
      "A birthday-ready hamper with a fragrant tea blend, chocolates, crisp biscuits and a bottle of sparkling wine, arranged for an easy celebration.",
    ],
    Features: [
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same.",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5148668",
    ],
  },
  {
    id: 5,
    name: "The Thank You Teacher Gift Box",
    category: "Gift Boxes",
    price: "60.00",
    reviews: "305",
    rating: "4.8",
    image: "/generated/products/p05-01.jpg",
    images: ["/generated/products/p05-01.jpg", "/generated/products/p05-02.jpg", "/generated/products/p05-03.jpg", "/generated/products/p05-04.jpg", "/generated/products/p05-05.jpg"],
    size: ["Medium Gift Box"],
    colors: ["Classic"],
    material: "Gift box, assorted food products",
    description: [
      "A warm thank-you for a brilliant teacher, bringing coffee, tea, sweets, fudge and hazelnut biscuits together in one tidy gift box.",
    ],
    Features: [
      "Breakfast Blend, 25 Tea Bags, 50g",
      "House Blend Ground Coffee, 75g",
      "Fudge, 300g",
      "Milk Chocolate Coated Praline Hazelnut Biscuits, 180g",
      "Strawberries & Cream Sweet Tin, 120g",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5189039",
    ],
  },
  {
    id: 6,
    name: "The Summer Gift Box",
    category: "Gift Boxes",
    price: "60.00",
    reviews: "198",
    rating: "4.4",
    image: "/generated/products/p06-01.jpg",
    images: ["/generated/products/p06-01.jpg", "/generated/products/p06-02.jpg", "/generated/products/p06-03.jpg", "/generated/products/p06-04.jpg", "/generated/products/p06-05.jpg", "/generated/products/p06-06.jpg", "/generated/products/p06-07.jpg"],
    size: ["Gift Box"],
    colors: ["Classic"],
    material: "Gift box, assorted food products",
    description: [
      "Citrus, berries and refreshing summer tea give this compact box its sunny character. Enjoy it as a thoughtful present or keep it ready for an afternoon lift.",
    ],
    Features: [
      "Summer Cooler, 20 Silky Tea Bag Tin, 50g",
      "Lemon and Vanilla Shortbread",
      "Strawberries & Cream Sweet Tin, 120g",
      "Blackcurrant & Cassis Curd, 195g",
      "Dark Chocolate Raspberry Filled Bar, 80g",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5249498",
    ],
  },
  {
    id: 7,
    name: "The failblossom City Gift Box",
    category: "Gift Boxes",
    price: "85.00",
    reviews: "240",
    rating: "4.7",
    image: "/generated/products/p07-01.jpg",
    images: ["/generated/products/p07-01.jpg", "/generated/products/p07-02.jpg", "/generated/products/p07-03.jpg", "/generated/products/p07-04.jpg", "/generated/products/p07-05.jpg", "/generated/products/p07-06.jpg", "/generated/products/p07-07.jpg"],
    size: ["Gift Box"],
    colors: ["Classic"],
    material: "Gift box, assorted food products",
    description: [
      "A city-inspired collection that brings failblossom favourites together in one expertly curated gift box.",
      "Tea and house-blend coffee sit alongside pistachio biscuits, olives, caramelised pecans, cranberry toast, strawberry preserve and a salted almond chocolate bar.",
    ],
    Features: [
      "Signature Blend, 15 Silky Teabags, 37.5g",
      "House Blend Ground Coffee Tin, 250g",
      "Pitted Green Olives in Brine, 200g",
      "Gluten-Free Sunflower Seed & Cranberry Toast, 100g",
      "Maple Caramelised Pecans, 80g",
      "Strawberry Preserve, 340g",
      "Pistachio & Clotted Cream Biscuits, 250g",
      "Milk Chocolate Salted Almond Bar, 80g",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5246718",
    ],
  },
  {
    id: 8,
    name: "The Champagne Celebration Box",
    category: "Gift Boxes",
    price: "90.00",
    reviews: "190",
    rating: "4.8",
    image: "/generated/products/p08-01.jpg",
    images: ["/generated/products/p08-01.jpg", "/generated/products/p08-02.jpg"],
    size: ["Gift Box"],
    colors: ["Classic"],
    material: "Gift box, assorted food products",
    description: [
      "A truly show-stopping gift, wow loved ones with our unbeatable Champagne Celebration Box. With four delectable chocolate truffle flavours to indulge in – from Milk Salted Caramel to our Dark Marc de Champagne Truffle – and the finest Blanc de Noirs Champagne, there's no better way to give your taste buds cause for celebration.",
      "The dry sparkling wine brings notes of orchard fruit and citrus, making a lively partner for the four rich truffle flavours included in the box.",
    ],
    Features: [
      "failblossom Blanc de Noirs Extra Brut Sparkling Wine, 75cl",
      "2x 165g Assorted Chocolate Truffle Tray, including:",
      "Milk Salted Caramel truffle",
      "Milk Raspberry Truffle",
      "Dark Sparkling Wine Truffle",
      "Milk Sea Salt Gianduja Truffle",
      "Please note, the items in this gift box will not arrive gift wrapped.",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5226094",
    ],
  },
  {
    id: 9,
    name: "The Cream Tea Selection",
    category: "Tea & Treats",
    price: "50.00",
    reviews: "256",
    rating: "4.7",
    image: "/generated/products/p09-01.jpg",
    images: ["/generated/products/p09-01.jpg", "/generated/products/p09-02.jpg", "/generated/products/p09-03.jpg", "/generated/products/p09-04.jpg", "/generated/products/p09-05.jpg", "/generated/products/p09-06.jpg", "/generated/products/p09-07.jpg"],
    size: ["Bag for Life"],
    colors: ["Classic"],
    material: "Bag for Life, assorted food products",
    description: [
      "Packed in a reusable tote, this selection includes afternoon tea, traditional teacakes, fresh plain and fruit mini scones, clotted cream and strawberry preserve for an easy teatime spread.",
    ],
    Features: [
      "Afternoon Blend, 25 Tea Bags, 50g",
      "Strawberry Preserve, 340g",
      "Organic Clotted Cream, 200ml",
      "failblossom Teacakes, Box of 4",
      "2x Mini Plain Scones",
      "2x Mini Fruit Scones",
      "failblossom Plastic-Free Bag for Life",
      "Please note, the preserves you receive may vary depending on availability and the clotted cream may look different to the one pictured.",
      "Please note, this product is not available for Click & Collect.",
      "Due to the inclusion of our freshly baked scones and our teacakes, The Cream Tea Selection has a shorter shelf life. We recommend you eat these quickly, as we can only guarantee a minimum shelf life of one day for the scones and ten days for the teacakes upon receipt of your order.",
      "Catalogue code: 5219159",
    ],
  },
  {
    id: 10,
    name: "The Champagne Cream Tea Selection",
    category: "Tea & Treats",
    price: "100.00",
    reviews: "312",
    rating: "4.9",
    image: "/generated/products/p10-01.jpg",
    images: ["/generated/products/p10-01.jpg", "/generated/products/p10-02.jpg", "/generated/products/p10-03.jpg", "/generated/products/p10-04.jpg", "/generated/products/p10-05.jpg", "/generated/products/p10-06.jpg", "/generated/products/p10-07.jpg", "/generated/products/p10-08.jpg", "/generated/products/p10-09.jpg"],
    size: ["Picnic Cool Bag"],
    colors: ["Classic"],
    material: "Picnic cool bag, assorted food products",
    description: [
      "A reusable picnic cool bag holds sparkling wine, afternoon tea, buttery clotted-cream biscuits, teacakes, mini scones, clotted cream and strawberry preserve for a celebratory picnic.",
    ],
    Features: [
      "failblossom Brut Reserve Sparkling Wine N.V, 75cl",
      "Afternoon Blend, 25 Tea Bags, 50g",
      "Clotted Cream Digestive Biscuits, 200g",
      "2x Mini Plain Scones",
      "2x Mini Fruit Scones",
      "Strawberry Preserve, 340g",
      "Organic Clotted Cream, 200g",
      "failblossom Teacakes, Box of 4",
      "failblossom Picnic Cool Bag",
      "Please note, the preserves you receive may vary depending on availability and the clotted cream may look different to the one pictured.",
      "Please note, this product is not available for Click & Collect.",
      "Due to the inclusion of our freshly baked scones and our teacakes, The Cream Tea Selection has a shorter shelf life. We recommend you eat these quickly, as we can only guarantee a minimum shelf life of one day for the scones and ten days for the teacakes upon receipt of your order.",
      "Catalogue code: 5094296",
    ],
  },
  {
    id: 11,
    name: "The Kir Royale Box",
    category: "Gift Boxes",
    price: "65.00",
    reviews: "198",
    rating: "4.6",
    image: "/generated/products/p11-01.jpg",
    images: ["/generated/products/p11-01.jpg", "/generated/products/p11-02.jpg", "/generated/products/p11-03.jpg", "/generated/products/p11-04.jpg", "/generated/products/p11-05.jpg"],
    size: ["Gift Box"],
    colors: ["Classic"],
    material: "Gift box, assorted beverages",
    description: [
      "The Kir Royale Box pairs dry sparkling wine with English cassis made from ripe blackcurrants, ready to mix into a vivid celebratory spritz.",
      "Perfect for toasting – cheers!"
    ],
    Features: [
      "Contains one 75cl and one 10cl bottle.",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 2004334",
      "0% ABV"
    ],
  },
  {
    id: 12,
    name: "The Cheese & Wine Hamper",
    category: "Hampers",
    price: "200.00",
    reviews: "267",
    rating: "4.5",
    image: "/generated/products/p12-01.jpg",
    images: ["/generated/products/p12-01.jpg", "/generated/products/p12-02.jpg", "/generated/products/p12-03.jpg", "/generated/products/p12-04.jpg", "/generated/products/p12-05.jpg"],
    size: ["Artisan"],
    colors: ["Classic"],
    material: "Wicker hamper, assorted food products",
    description: [
      "Equally at home beside a fire or on a picnic rug.",
      "Red and white wines meet cave-aged cheddar, Stilton, Brie, savoury biscuits and condiments in a practical wicker hamper.",
      "A reusable cool bag helps carry the chilled items, while the sturdy lid can serve as a simple cheese board."
    ],
    Features: [
      "Côtes du Rhône, 75cl 13.5% ABV",
      "Casablanca Sauvignon Blanc, 75cl 13% ABV",
      "Cave Aged Cheddar Wedge, 400g",
      "Traditional Stilton Jar, 200g",
      "British Brie, 250g",
      "Quince Cheese, 120g",
      "Caramelised Onion Marmalade, 230g",
      "Chef Honey Smoked Chipotle, 200g",
      "Ancient Grain Oatcake, 180g",
      "Rosemary & Thyme Sable, 160g",
      "Gluten Free Cranberry & Sunflower Seed Toasts, 100g",
      "failblossom Picnic Cool Bag",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5225931"
    ],
  },
  {
    id: 13,
    name: "The Celebration Pantry Hamper",
    category: "Hampers",
    price: "250.00",
    reviews: "223",
    rating: "4.6",
    image: "/generated/products/p13-01.jpg",
    images: ["/generated/products/p13-01.jpg", "/generated/products/p13-02.jpg", "/generated/products/p13-03.jpg", "/generated/products/p13-04.jpg", "/generated/products/p13-05.jpg", "/generated/products/p13-06.jpg"],
    size: ["Celebration"],
    colors: ["Classic"],
    material: "Wicker hamper, assorted food products",
    description: [
      "A generous pantry deserves a generous hamper.",
      "This celebration-ready wicker balances teatime favourites, wines, preserves, savoury condiments and confectionery for gatherings large and small.",
      "Carefully packed so that every layer reveals something new to share."
    ],
    Features: [
      "Please note, the items in this hamper will not arrive gift wrapped.",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5164009"
    ],
  },
  {
    id: 14,
    name: "The Bloody Mary Box",
    category: "Gift Boxes",
    price: "75.00",
    reviews: "198",
    rating: "4.7",
    image: "/generated/products/p14-01.jpg",
    images: ["/generated/products/p14-01.jpg", "/generated/products/p14-02.jpg"],
    size: ["Gift Box"],
    colors: ["Classic"],
    material: "Gift box, assorted beverages and condiments",
    description: [
      "This selection brings together the essentials for a savoury, spicy Bloody Mary: English apple vodka, rich red tomato juice, horseradish, chilli sauce and celery salt.",
      "Mix it gently over ice, adjust the heat to taste and finish the glass with a pinch of celery salt."
    ],
    Features: [
      "failblossom English Apple Vodka, 20cl",
      "Rich Red Tomato Juice, 330ml",
      "Hot Horseradish Sauce, 200g",
      "Hot Chilli Sauce, 100ml",
      "Celery Salt Tin No 101, 84g",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5167551"
    ],
  },
  {
    id: 15,
    name: "The After Dinner Gift Box",
    category: "Gift Boxes",
    price: "45.00",
    reviews: "312",
    rating: "4.8",
    image: "/generated/products/p15-01.jpg",
    images: ["/generated/products/p15-01.jpg", "/generated/products/p15-02.jpg", "/generated/products/p15-03.jpg", "/generated/products/p15-04.jpg", "/generated/products/p15-05.jpg", "/generated/products/p15-06.jpg", "/generated/products/p15-07.jpg"],
    size: ["Gift Box"],
    colors: ["Deep Teal"],
    material: "Keepsake box, assorted sweet treats",
    description: [
      "Presented in a deep-teal keepsake box, this collection brings together mint infusion, traditional shortbread, cool mints and chocolate napolitains for a relaxed after-dinner ritual."
    ],
    Features: [
      "English Mint Infusion Tin, 22.5g",
      "12 Piece Milk & Dark Napolitains, 78g",
      "Icy Mins, 125g",
      "Traditional Shortbread, 125g",
      "Please note, the items in this gift box will not arrive gift wrapped.",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5225925"
    ],
  },
  {
    id: 16,
    name: "The Congratulations Hamper",
    category: "Hampers",
    price: "225.00",
    reviews: "187",
    rating: "4.7",
    image: "/generated/products/p16-01.jpg",
    images: ["/generated/products/p16-01.jpg", "/generated/products/p16-02.jpg", "/generated/products/p16-03.jpg", "/generated/products/p16-04.jpg", "/generated/products/p16-05.jpg", "/generated/products/p16-06.jpg", "/generated/products/p16-07.jpg"],
    size: ["Celebration"],
    colors: ["Classic"],
    material: "Wicker hamper, assorted food products",
    description: [
      "A good reason to open something sparkling.",
      "Tea, biscuits, fruit preserves and truffles round out the bottle, making this wicker hamper ready for milestones and spontaneous celebrations alike."
    ],
    Features: [
      "Blanc de Noirs Extra Brut, 75cl 12.5%ABV",
      "Celebration Tea Blend, 250g",
      "Scottish Ling Heather Honey Biscuits, 250g",
      "Orange & Champagne Marmalade, 200g",
      "Strawberry & Champagne Preserve, 200g",
      "Salted Caramel Milk Chocolate Florentines, 150g",
      "Marc de Champagne Truffle Drum, 125g",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5246725"
    ],
  },
  {
    id: 17,
    name: "The Rosé Sparkling Celebration Box",
    category: "Gift Boxes",
    price: "135.00",
    reviews: "234",
    rating: "4.6",
    image: "/generated/products/p17-01.jpg",
    images: ["/generated/products/p17-01.jpg", "/generated/products/p17-02.jpg", "/generated/products/p17-03.jpg", "/generated/products/p17-04.jpg"],
    size: ["Gift Box"],
    colors: ["Classic"],
    material: "Gift box, assorted food products",
    description: [
      "Rosé sparkling wine and pale-pink truffles make this a bright, celebratory pairing.",
      "The wine is crisp and fruit-led, while the truffles add a rich cocoa finish.",
      "Presented together in a blush gift box designed for effortless gifting."
    ],
    Features: [
      "2x Pink Sparkling Wine Truffle Tray, 165g",
      "failblossom Brut Rosé Sparkling Wine, 75cl",
      "Please note, the items in this gift box will not arrive gift wrapped.",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5226096"
    ],
  },
  {
    id: 18,
    name: "The Personalised Sparkling Celebration Box",
    category: "Gift Boxes",
    price: "145.00",
    reviews: "201",
    rating: "4.6",
    image: "/generated/products/p18-01.jpg",
    images: ["/generated/products/p18-01.jpg", "/generated/products/p18-02.jpg", "/generated/products/p18-03.jpg", "/generated/products/p18-04.jpg"],
    size: ["Gift Box"],
    colors: ["Classic"],
    material: "Gift box, assorted food products",
    description: [
      "Add a personal message to the sparkling wine label for a gift made especially for its recipient.",
      "The presentation box pairs the customized bottle with four chocolate truffle flavours, from salted caramel to dark sparkling-wine ganache.",
      "The dry sparkling wine has bright orchard-fruit and citrus notes."
    ],
    Features: [
      "failblossom Blanc de Noirs Extra Brut Sparkling Wine, 75cl - with a personalisable label",
      "2x 165g Assorted Chocolate Truffle Tray, including:",
      "Milk Salted Caramel truffle",
      "Milk Raspberry Truffle",
      "Dark Sparkling Wine Truffle",
      "Milk Sea Salt Gianduja Truffle",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5226095"
    ],
  },
  {
    id: 19,
    name: "The Quartet of Reds Gift Box",
    category: "Gift Boxes",
    price: "180.00",
    reviews: "276",
    rating: "4.8",
    image: "/generated/products/p19-01.jpg",
    images: ["/generated/products/p19-01.jpg", "/generated/products/p19-02.jpg", "/generated/products/p19-03.jpg", "/generated/products/p19-04.jpg", "/generated/products/p19-05.jpg"],
    size: ["Gift Box"],
    colors: ["Classic"],
    material: "Gift box, assorted wine",
    description: [
      "Four characterful red wines bring together bright red fruit, rich blackberry, gentle spice and rounded tannins in a presentation box made for sharing."
    ],
    Features: [
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5225933"
    ],
  },
  {
    id: 20,
    name: "The Classic Wine Selection Hamper",
    category: "Hampers",
    price: "195.00",
    reviews: "189",
    rating: "4.6",
    image: "/generated/products/p20-01.jpg",
    images: ["/generated/products/p20-01.jpg", "/generated/products/p20-02.jpg", "/generated/products/p20-03.jpg"],
    size: ["Wicker"],
    colors: ["Classic"],
    material: "Wicker hamper, assorted wine",
    description: [
      "Two bright whites and two rounded reds make a versatile four-bottle selection, packed into a handled wicker basket for easy gifting and future reuse."
    ],
    Features: [
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5220315"
    ],
  },
  {
    id: 21,
    name: "The Quartet of Whites Gift Box",
    category: "Gift Boxes",
    price: "175.00",
    reviews: "200",
    rating: "4.7",
    image: "/generated/products/p21-01.jpg",
    images: ["/generated/products/p21-01.jpg", "/generated/products/p21-02.jpg", "/generated/products/p21-03.jpg", "/generated/products/p21-04.jpg"],
    size: ["Gift Box"],
    colors: ["Classic"],
    material: "Gift box, assorted wine",
    description: [
      "Four European white wines offer a lively range of citrus, green apple, gooseberry, honeysuckle and stone-fruit notes, presented together for tasting or gifting."
    ],
    Features: [
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5225934"
    ],
  },
  {
    id: 22,
    name: "The Personalised Rosé Sparkling Celebration Box",
    category: "Gift Boxes",
    price: "155.00",
    reviews: "210",
    rating: "4.8",
    image: "/generated/products/p22-01.jpg",
    images: ["/generated/products/p22-01.jpg", "/generated/products/p22-02.jpg", "/generated/products/p22-03.jpg"],
    size: ["Gift Box"],
    colors: ["Classic"],
    material: "Gift box, assorted food products",
    description: [
      "Personalise the rosé sparkling wine label with a special note, then present it alongside two trays of pale-pink truffles.",
      "Fresh berry notes in the wine complement the rich cocoa and sparkling-wine ganache at the centre of each truffle."
    ],
    Features: [
      "failblossom Brut Rosé Sparkling Wine, 75cl - with a personalisable label",
      "2x Pink Sparkling Wine Truffle Tray, 165g",
      "Please note, the items in this gift box will not arrive gift wrapped.",
      "All our hampers are carefully woven by hand, meaning each wicker is unique with no two the same",
      "Catalogue code: 5226097"
    ],
  },
];

export default productData;
